export enum DownloadFormat {
  Csv = "csv",
  Json = "json",
  Ndjson = "ndjson",
}
